<template>
  <div class="container-fluid customer-profile-container">
    <b-card
      class="
        card-transparent-background card-customer-profile-container-dy
        mt-md-5 mt-1
      "
    >
      <!-- subscriptions -->
      <b-row class="mt-md-5 mt-1">
        <b-col lg="10" md="11" class="mx-auto">
          <VueSlickCarousel
            v-bind="settings_slick"
            class="slick-container-dy subscription-slick-container-dy"
          >
            <template #prevArrow>
              <div class="custom-arrow">
                <img src="@/assets/images/doom-yoga/arrow-left.png" />
              </div>
            </template>
            <b-card
              v-for="item in subscriptions_list"
              :key="item.id"
              class="
                card-dark-transparent-background-dy
                subscription-card-dy
                text-center
              "
              :class="{ selected: item.id == selected_subscription_id }"
              :title="item.title"
            >
              <b-card-sub-title class="mb-2"
                >{{ item.price }} <span> / {{ item.frequency }}</span>
              </b-card-sub-title>

              <div class="subscription-divide-dy"></div>

              <div
                class="subscription-benifits-div-dy"
                v-html="item.benifits"
              ></div>

              <b-button
                v-if="item.id != selected_subscription_id"
                variant="cutomer-primary"
                class="btn-bumblebee btn-doomyoga w-50"
                @click="clickBuySubscription(item.id)"
                >Buy
              </b-button>
            </b-card>
            <template #nextArrow>
              <div class="custom-arrow">
                <img src="@/assets/images/doom-yoga/arrow-right.png" />
              </div>
            </template>
          </VueSlickCarousel>
        </b-col>
      </b-row>
      <!-- card details -->
      <b-row>
        <b-col lg="10" md="12" class="mx-auto">
          <b-card class="card-dark-transparent-background-dy">
            <b-row class="row-profile-no-border-dy my-2" align-v="center"
              ><b-col lg="10" md="12" class="pl-0">
                <b-form-group
                  class="form-group-edit-profile-dy"
                  label-cols="12"
                  label-cols-md="4"
                  label-cols-lg="3"
                  content-cols="12"
                  content-cols-md="12"
                  content-cols-lg="9"
                  label-align="left"
                  label="Payment details"
                >
                  <span
                    class="profile-data-value-doom-yoga"
                    v-if="!is_edit_card"
                  >
                    **** **** **** {{ last_card_digits }}
                  </span>
                  <StripeComponentPayment
                    client_name="DY"
                    ref="paymentform"
                    element_class_base="form-control form-control-profile form-control-profile-doom-yoga"
                    v-if="is_edit_card == true"
                    :require_card="is_edit_card"
                    display_label="true"
                    form_group_class="form-group-edit-profile-dy form-group-sub-edit-profile-dy"
                    :stripe_token.sync="stripe_token"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2" md="12" class="pr-0">
                <div class="float-right">
                  <b-button
                    v-if="!is_edit_card"
                    variant="edit-input-dy"
                    @click="clickEditCard"
                  >
                    Edit
                  </b-button>
                  <b-button
                    v-if="is_edit_card"
                    variant="edit-input-dy"
                    @click="clickChangeCard"
                  >
                    Change
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";
import StripeComponentPayment from "@/components/Payment/StripeComponentPayment";

export default {
  name: "DoOmYogaCustomerProfileSubscription",
  components: { StripeComponentPayment },
  data() {
    return {
      selected_subscription_id: 2,
      subscriptions_list: [
        {
          id: 1,
          title: "Weekly",
          benifits: "yoga videos livestream",
          frequency: "week",
          price: "£50",
        },
        {
          id: 2,
          title: "Monthly",
          benifits: "yoga videos  livestream",
          frequency: "month",
          price: "£180",
        },
        {
          id: 3,
          title: "Yearly",
          benifits:
            "yoga videos livestream yoga videos livestream yoga videos livestream yoga videos livestream",
          frequency: "month",
          price: "£500",
        },
      ],
      settings_slick: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        adaptiveHeight: false,
        responsive: [
          //col-xl-2 col-lg-3 col-md-3 col-6
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      last_card_digits: "1234",
      is_edit_card: false,
      stripe_token: null,
    };
  },
  methods: {
    clickEditCard() {
      console.log("click edit card");
      this.is_edit_card = true;
    },
    async clickChangeCard() {
      console.log("click change card");
      this.stripe_token = null
      // this.is_edit_card = false;
      console.log(this.stripe_token);
      await this.$refs.paymentform.purchase();
      console.log(this.stripe_token);
      this.is_edit_card = false;
    },
    clickBuySubscription(id) {
      console.log("click buy subscription ", id);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Profile/Subscription.vue